import { View, Text, TouchableOpacity, Platform } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';

interface Props {
  devSeCount: number | null;
  devSeRows: any[] | null;
  devSeLoading: boolean;
  devPingResult: string | null;
  devPingLoading: boolean;
  onQueryStrengthEvents: () => void;
  onPingFunction: () => void;
}

export default function DevStrengthPanel({
  devSeCount,
  devSeRows,
  devSeLoading,
  devPingResult,
  devPingLoading,
  onQueryStrengthEvents,
  onPingFunction,
}: Props) {
  const { theme } = useTheme();

  if (!__DEV__) return null;

  return (
    <View style={{ padding: 16, borderTopWidth: 1, borderTopColor: theme.colors.border, gap: 10 }}>
      <TouchableOpacity
        style={{ backgroundColor: theme.colors.surfaceVariant, padding: 10, borderRadius: 0, alignItems: 'center' }}
        onPress={onQueryStrengthEvents}
        disabled={devSeLoading}>
        <Text style={{ color: theme.colors.accent, fontWeight: '700', fontSize: 13 }}>
          {devSeLoading ? 'Loading…' : 'DEV: Query strength_events'}
        </Text>
      </TouchableOpacity>
      {devSeCount !== null && (
        <View style={{ marginTop: 4 }}>
          <Text style={{ color: theme.colors.text, fontSize: 12, fontWeight: '700' }}>
            strength_events count: {devSeCount}
          </Text>
          {devSeCount === -1 ? (
            <Text style={{ color: theme.colors.error, fontSize: 11 }}>strength_events: blocked/unavailable (RLS?)</Text>
          ) : devSeRows && devSeRows.length > 0 ? (
            devSeRows.map((row: any, i: number) => (
              <Text key={row.id ?? i} style={{ color: theme.colors.textSecondary, fontSize: 11, fontFamily: Platform.OS === 'web' ? 'monospace' : undefined }}>
                {row.lift_key} | {row.weight}×{row.reps} | {row.performed_at?.slice(0, 16)}
              </Text>
            ))
          ) : (
            <Text style={{ color: theme.colors.textTertiary, fontSize: 11 }}>No rows found.</Text>
          )}
        </View>
      )}
      <TouchableOpacity
        style={{ backgroundColor: theme.colors.surfaceVariant, padding: 10, borderRadius: 0, alignItems: 'center' }}
        onPress={onPingFunction}
        disabled={devPingLoading}>
        <Text style={{ color: theme.colors.accent, fontWeight: '700', fontSize: 13 }}>
          {devPingLoading ? 'Pinging…' : 'DEV: Ping insert_strength_events'}
        </Text>
      </TouchableOpacity>
      {devPingResult !== null && (
        <Text
          style={{ color: theme.colors.textSecondary, fontSize: 11, marginTop: 4, fontFamily: Platform.OS === 'web' ? 'monospace' : undefined }}
          selectable>
          {devPingResult}
        </Text>
      )}
    </View>
  );
}
